"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _template = _interopRequireDefault(require("lodash/template"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactLazyLoad = _interopRequireDefault(require("react-lazy-load"));
var _environment = _interopRequireDefault(require("@spothero/utils/environment"));
var _PulseLoader = _interopRequireDefault(require("../../../PulseLoader/PulseLoader"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Image extends _react.Component {
  static defaultProps = {
    showLoader: true,
    lazyLoadOffsetVertical: 100,
    quality: 50,
    cloudinaryCloudName: 'spothero'
  };
  constructor(props) {
    super(props);
    const {
      cloudinaryImageId,
      cloudinaryTemplate
    } = props;
    this._imageProps = (0, _omit.default)(props, ['className', 'showLoader', 'lazyLoad', 'lazyLoadOffsetVertical', 'cloudinaryCloudName', 'cloudinaryImageId', 'cloudinaryTemplate', 'quality', 'onLoad']);
    this.state = {
      isLoaded: false,
      hasCloudinarySrc: !(cloudinaryImageId || cloudinaryTemplate)
    };
  }
  componentDidMount() {
    const {
      cloudinaryCloudName,
      cloudinaryTemplate,
      cloudinaryImageId,
      width,
      height,
      quality
    } = this.props;
    if (cloudinaryImageId || cloudinaryTemplate) {
      // cloudinary image provided, create the source path

      if (this.isCloudinaryImageAndInvalid()) {
        return;
      }
      const tmpl = cloudinaryTemplate ? cloudinaryTemplate : `https://res.cloudinary.com/${cloudinaryCloudName}/image/upload/$w_{{WIDTH}},$h_{{HEIGHT}},$q_{{QUALITY}}/c_fill,f_auto,fl_progressive,dpr_${_environment.default.isHighDensityDisplay() ? 2 : 1},h_$h,q_$q,w_$w/${cloudinaryImageId}`;
      this._imageProps.src = (0, _template.default)(tmpl, {
        interpolate: /{{([\s\S]+?)}}/g // matches template vars in the format '{{ var }}' or '{{var}}'
      })({
        WIDTH: width,
        HEIGHT: height,
        QUALITY: quality
      });

      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        hasCloudinarySrc: true
      });
    }
  }
  _onLoaded = evt => {
    const {
      onLoad
    } = this.props;
    this.setState({
      isLoaded: true
    });
    if (onLoad) {
      onLoad(evt);
    }
  };
  isCloudinaryImageAndInvalid = () => {
    const {
      cloudinaryImageId,
      cloudinaryTemplate,
      width,
      height
    } = this.props;
    return (cloudinaryImageId || cloudinaryTemplate) && (!width || !height);
  };
  _renderImage() {
    const {
      className,
      width,
      height,
      showLoader
    } = this.props;
    const {
      isLoaded
    } = this.state;
    const classes = (0, _classnames.default)(className, 'Image-container');
    const imgClasses = (0, _classnames.default)('Image', {
      'Image-loaded': isLoaded
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes,
      style: {
        maxWidth: width,
        maxHeight: height
      }
    }, showLoader && !isLoaded && /*#__PURE__*/_react.default.createElement(_PulseLoader.default, {
      size: 32,
      borderWidth: 2
    }), /*#__PURE__*/_react.default.createElement("img", (0, _extends2.default)({}, this._imageProps, {
      className: imgClasses,
      onLoad: this._onLoaded
    })));
  }
  render() {
    const {
      lazyLoad,
      lazyLoadOffsetVertical
    } = this.props;
    const {
      hasCloudinarySrc
    } = this.state;

    // the source is set after component is mounted in the case of Cloudinary images otherwise there are mis-matching
    // DPR attributes in the url since node will always set the DPR to 1 and high density displays will have it set to 2+.
    if (!hasCloudinarySrc) {
      return null;
    }
    if (this.isCloudinaryImageAndInvalid()) {
      return null;
    }
    if (lazyLoad) {
      return /*#__PURE__*/_react.default.createElement(_reactLazyLoad.default, {
        offsetVertical: lazyLoadOffsetVertical
      }, this._renderImage());
    }
    return this._renderImage();
  }
}
exports.default = Image;